/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/

import { SvgIcon, SvgIconProps } from '@material-ui/core';

const ServiceIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 18 18">
    <path d="M12.75 12L9.75 9V6.615C10.62 6.3 11.25 5.475 11.25 4.5C11.25 3.255 10.245 2.25 9 2.25C7.755 2.25 6.75 3.255 6.75 4.5C6.75 5.475 7.38 6.3 8.25 6.615V9L5.25 12H2.25V15.75H6V13.4625L9 10.3125L12 13.4625V15.75H15.75V12H12.75Z" />
  </SvgIcon>
);

export default ServiceIcon;
